import { FileTypeEnum } from 'api/files';
import { useAsyncResource } from 'back-office/shared/hooks/useAsyncResource';
import { useCallback } from 'react';
import { filesAPI } from 'services/swagger-api';

/** Relevé d'information de sinistralité : justificatif du devis, pas du souscripteur. */
export const CLAIMS_STATEMENT_FILE_TYPE = FileTypeEnum.ReleveInformationSinistralite;

/**
 * Relevé d'information de sinistralité déposé sur le devis : présent ou non, avec de quoi
 * l'ouvrir et le retirer. `reload()` après chaque dépôt ou retrait.
 */
export const useClaimsStatementDocument = (quoteId?: string) => {
  const fetcher = useCallback(
    () => filesAPI.getDevisDocumentInfo({ devisId: quoteId as string, fileType: CLAIMS_STATEMENT_FILE_TYPE }),
    [quoteId]
  );

  return useAsyncResource(fetcher, quoteId != null);
};
